import { useCallback } from "react";
import { CompanyType } from "$types/CompanyType";

const { AGENCY, CARRIER, CLIENT, CONTRIBUTOR, LOGISTICIAN, SUPPLIER } =
  CompanyType;

const useCompany = () => {
  const isAgency = useCallback(
    (companyTypes?: CompanyType | CompanyType[]): boolean =>
      Array.isArray(companyTypes)
        ? companyTypes.includes(AGENCY)
        : companyTypes === AGENCY,
    []
  );
  const isCarrier = useCallback(
    (companyTypes?: CompanyType | CompanyType[]): boolean =>
      Array.isArray(companyTypes)
        ? companyTypes.includes(CARRIER)
        : companyTypes === CARRIER,
    []
  );
  const isClient = useCallback(
    (companyTypes?: CompanyType | CompanyType[]): boolean =>
      Array.isArray(companyTypes)
        ? companyTypes.includes(CLIENT)
        : companyTypes === CLIENT,
    []
  );
  const isContributor = useCallback(
    (companyTypes?: CompanyType | CompanyType[]): boolean =>
      Array.isArray(companyTypes)
        ? companyTypes.includes(CONTRIBUTOR)
        : companyTypes === CONTRIBUTOR,
    []
  );
  const isLogistician = useCallback(
    (companyTypes?: CompanyType | CompanyType[]): boolean =>
      Array.isArray(companyTypes)
        ? companyTypes.includes(LOGISTICIAN)
        : companyTypes === LOGISTICIAN,
    []
  );
  const isSupplier = useCallback(
    (companyTypes?: CompanyType | CompanyType[]): boolean =>
      Array.isArray(companyTypes)
        ? companyTypes.includes(SUPPLIER)
        : companyTypes === SUPPLIER,
    []
  );

  return {
    isAgency,
    isCarrier,
    isClient,
    isContributor,
    isLogistician,
    isSupplier,
  };
};

export default useCompany;
